<template>
    <div class="rooms-header">
        <div class="header-tabs">
            <div class="tabs" style="margin-left:12px">
                <div style="text-align:center;margin-top:54px"><span style="font-size:20px">会议室主机安装包</span></div>
                <div style="display:flex;justify-content: center;margin-top:36px">
                    <div class="beijing2" @mousemove="getsg()" @mouseleave="getgss()" @click="getxia()">
                        <div style="text-align:center">
                            <img src="@/assets/image/beijng3.png" alt="" style="width:100px;" class="imgs" v-if="ind ==0">
                            <img src="@/assets/image/xiaz.png" alt="" style="width:100px;" class="imgs" v-else-if="ind ==1">
                        </div>
                        <p style="margin-top:64px"><span style="font-size:19px;color:#fff">Windows安装包</span></p>
                    </div>
                    <div class="beijing3" style="margin-left:25px" @mousemove="getsg1()" @mouseleave="getgss1()" @click="getaxia()">
                        <div style="text-align:center">
                            <img src="@/assets/image/azhuo.png" alt="" style="width:100px;" v-if="ind1 ==0">
                            <img src="@/assets/image/xiaz.png" alt="" style="width:100px;" v-else-if="ind1 ==1">
                        </div>
                        <p style="margin-top:64px"><span style="font-size:19px;color:#fff">Android安装包</span></p>
                    </div>
                </div>
            </div>
            <div style="width: 399px;height: 588px;background: #FFFFFF;border-radius: 20px;position: relative;left: -12px; box-shadow: 0 0 5px 3px rgba(14, 113, 235, 0.15);">
                <div style="text-align:center;margin-top:54px"><span style="font-size: 20px;">会议室控制器安装包</span></div>
                <div style="height: 39px;font-size: 14px;color: #5B5B5B;text-align:center;margin-top:20px;"><span style="width: 299px;display:inline-block">将「红杉会议Rooms控制器」安装在安卓平板上对红杉会议Rooms进行便捷的会议管控</span></div>
                <div style="text-align:center;margin-top:69px" >
                    <img src="@/assets/image/erma.png" alt="" style="width:400px">
                </div>
                <div style="text-align:center;margin-top:20px">
                    <span style="font-size: 16px;color: #5B5B5B;">扫描二维码下载客户端</span>
                </div>
            </div>
        </div>
        <div class="kehu">
            <span style="font-size: 16px;color: #5B5B5B;text-align:center;display:inline-block;width:100%;margin-top:60px">Rooms使用引导</span>
            <div style="display: flex;justify-content: space-around;">
              <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/yi.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">硬件连接</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/dianshi.png" alt="" style="margin-top:5px">
                </div>
                <div style="margin-left:36px;margin-top:33px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>确认安装Rooms软件的硬件终端已经准备好</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>连接麦克风、扬声器、显示器、摄像头等设备 </p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/er.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">Rooms软件安装</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/biao.png" alt="">
                </div>
                <div style="margin-left:36px;margin-top:13px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>下载Rooms软件，并在硬件终端上安装</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>设置站点，并绑定Rooms账号</p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/san.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">开始会议</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/kaihui.png" alt="">
                </div>
                <div style="margin-left:36px;margin-top:13px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>Rooms 支持发起会议和加入会议，并与其他客户端音视频互动</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;margin-top:15px"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>PC或手机端可以一键投屏Rooms，实时共享内容</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            ind:0,
            ind1:0,
        }
    },
    methods:{
        getsg(){
             this.ind = 1
        },
        getgss(){
             this.ind = 0
        },
         getsg1(){
             this.ind1 = 1
        },
        getgss1(){
             this.ind1 = 0
        },
        getxia(){
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
            a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_WindowsRooms.zip'
            a.click()
            window.URL.revokeObjectURL(url)
        },
        getaxia(){
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
            a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_AndroidRooms.zip'
            a.click()
            window.URL.revokeObjectURL(url)
        }
    }
}
</script>
<style lang="scss">

    .rooms-header{
        width: 1240px;
        margin: 0 auto;
        position: relative;
        top:300px;
        .header-tabs{
          
            display: flex;
           
            justify-content: space-between;
              
            .tabs{
               width: 752px;
               height: 588px;
               background: url('../../assets/image/beitu3.png');
               box-shadow: 0 0 5px 3px rgba(14, 113, 235, 0.15);
               border-radius: 20px;
               .beijing2{
                   width: 304px;
                   height: 386px;
                   background: url('../../assets/image/beijing2.png');
                   text-align: center;
                   display: flex;
                   flex-direction: column;
                   justify-content: center;
                   cursor: pointer;
                   
               }
               .beijing3{
                   width: 304px;
                   height: 386px;
                   background: url('../../assets/image/beijing2.png');
                   text-align: center;
                   display: flex;
                   flex-direction: column;
                   justify-content: center;
                cursor: pointer;
               }
            }
        }
        .kehu{
            .ktabs{
                width: 386px;
                height: 447px;
                background: #FFFFFF;
                border: 1px solid #CAD9FF;
                border-radius: 10px;
                margin-top: 20px;
            }
        }
    }
    
</style>